import { map } from "lodash";

/** Maps each value by dividing by `ratio` (e.g. SEK vs EUR cent scaling for sliders). */
export const amountValuesList = (values: number[], ratio: number): number[] =>
  map(values, (n) => n / ratio);
